import { getApiBaseUrl } from "./apiBase";

export const GAMIFICATION_API = `${getApiBaseUrl()}/gamification`;

export function gamificationEndpoints(scope = "team", gameId = "") {
  if (scope === "team") {
    return {
      overview: `${GAMIFICATION_API}/team/overview`,
      learners: `${GAMIFICATION_API}/team/learners`,
      learner: (messengerId) =>
        `${GAMIFICATION_API}/team/learners/${messengerId}`,
    };
  }

  return {
    overview: `${GAMIFICATION_API}/${gameId}`,
    learners: `${GAMIFICATION_API}/${gameId}/learners`,
    learner: (messengerId) =>
      `${GAMIFICATION_API}/${gameId}/learners/${messengerId}`,
  };
}

export function learnerDisplayName(learner) {
  return learner.displayName || learner.username || `ID ${learner.messengerId}`;
}

export function learnerAccuracy(row) {
  if (row.totalAnswers) {
    return `${Math.round((row.totalCorrect / row.totalAnswers) * 100)}%`;
  }
  if (row.bestAccuracy) {
    return `${Math.round(row.bestAccuracy)}%`;
  }
  return "—";
}

export function rankBadge(rank) {
  if (rank === 1) return "🥇";
  if (rank === 2) return "🥈";
  if (rank === 3) return "🥉";
  return `#${rank}`;
}
